import { EndPoint } from './config';
import { RestService } from './ResyService';
export class Dashboard extends RestService {
    getDashboard() {
        return this.get(EndPoint.dashboard);
    }
}